var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsStarTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 373.38 373.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-3 {\n        fill: #921b80;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 186.69,
    cy: 186.69,
    r: 186.69
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Street_Right",
    "data-name": "Street Right"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 186.69,
    cy: 186.69,
    r: 186.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "186.69 41.09 217.39 135.58 316.73 135.58 236.36 193.97 267.06 288.45 186.69 230.06 106.32 288.45 137.02 193.97 56.65 135.58 155.99 135.58 186.69 41.09"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsStarTravel);
export default __webpack_public_path__ + "static/media/news-star-travel.bb01776f633f906efb402aa6216eb993.svg";
export { ForwardRef as ReactComponent };